import React from 'react';
import { css } from '@emotion/react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '@store/hooks';
import { RootState } from '@store/store';
import { useChatPlayContext } from '@provider/ChatPlayProvider';
import NextChapter from '@/components/chatStory/popup/NextChapter';

import ChoiceList from './choice/ChoiceList';
import AutoPlay from './AutoPlay';
import Background from './Background';

interface IChatBackGround {
  isClickableRef: React.MutableRefObject<boolean>;
}

const ChatBackground = ({ isClickableRef }: IChatBackGround) => {
  const { playChapterInfo } = useAppSelector(
    (state: RootState) => state.chapter,
    shallowEqual,
  );

  const {
    background,
    endingPopupInfo,
    autoPlayType,
    fastRateRef,
    onChatGPTMode,
  } = useChatPlayContext();
  const {
    setAutoPlayType,
    onAutoPlayRate,
    resetEnding,
    onChoice,
    onChatProgress,
  } = useChatPlayContext();

  const onClickChat = () => {
    isClickableRef.current && onChatProgress('click');
  };
  return (
    <div css={container}>
      <Background
        imageLink={background?.file?.link || ''}
        onClick={() => {
          autoPlayType === 'hidden' && onClickChat();
        }}
      >
        <>
          {endingPopupInfo?.isShow && !endingPopupInfo?.ending?.isFinal && (
            <NextChapter
              storyImage={endingPopupInfo?.ending?.imageFile?.link}
              nextChapter={
                endingPopupInfo?.nextChapter?.publishedAt
                  ? endingPopupInfo?.nextChapter
                  : undefined
              }
              charName={
                (playChapterInfo?.mainCharacterName?.lastName || '') +
                playChapterInfo?.mainCharacterName?.firstName
              }
              reset={resetEnding}
              contentType="interactive"
            />
          )}
          <ChoiceList onChoice={onChoice} />
          {fastRateRef && !onChatGPTMode && (
            <AutoPlay
              type={autoPlayType}
              playRate={fastRateRef.current}
              onPress={(isPlay: boolean) => {
                setAutoPlayType(isPlay ? 'play' : 'hidden');
              }}
              onRate={onAutoPlayRate}
            />
          )}
        </>
      </Background>
    </div>
  );
};

const container = css`
  position: relative;
  height: 30%;
`;
export default ChatBackground;
